<script setup lang="ts">
const { t } = useI18n();
const appConfig = useRuntimeConfig().public;
const isGameHighlightsEnabled = appConfig.APP_CUSTOMER.enable_game_highlights;
const isRecommendedEnabled = appConfig.APP_CUSTOMER.enable_recommended_section;
const showRecommendedSection = isRecommendedEnabled;
const showRecommendedSectionInTheTop = appConfig.APP_CUSTOMER.enable_top_recommended_section;

definePageMeta({ layout: "home" });
</script>

<template>
  <div class="pb-8">
    <BlockHomeSlider class="mb-5" />

    <UserRecommendation v-if="showRecommendedSection && showRecommendedSectionInTheTop" />

    <BaseEventSlider :title="t('labels.live')" type="live" />
    <BaseEventSlider :title="t('labels.upcoming')" type="upcoming" />

    <UserRecommendation v-if="showRecommendedSection && !showRecommendedSectionInTheTop" />

    <ListEvents
      :title="t('labels.latest')"
      class="text-2xl main-container text-main"
      hide-on-no-content
      has-see-all-link
    >
      <template #end>
        <div class="mt-10 hr" role="separator" />
      </template>
    </ListEvents>

    <ListEvents
      v-if="isGameHighlightsEnabled"
      :title="t('labels.highlights', 0)"
      type="highlight"
      class="text-2xl main-container text-main"
      hide-on-no-content
      has-see-all-link
    />
  </div>
</template>
